import { Item } from "Models/item";
import { ItemTypes } from "Models/item.types";

type ResolveItemVolumeArgs = {
  item?: Item | null;
  itemTypeId?: number | null;
  itemsType?: ItemTypes[] | null;
};

export const resolveItemVolume = ({
  item,
  itemTypeId,
  itemsType,
}: ResolveItemVolumeArgs): number | undefined => {
  const itemTypeFound =
    itemTypeId && itemsType && itemsType.length > 0
      ? itemsType.find((itemType) => itemType?.id === itemTypeId)
      : null;

  if (itemTypeFound?.isBox && itemTypeFound?.volume) {
    return itemTypeFound.volume;
  }

  return item?.volume;
};
